/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:22
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').
    controller('WebSiteLoyaltyCardCtrl',["$log","$scope","$anchorScroll","$rootScope","$routeParams","$location","LoyaltyCardData","$timeout", "gettextCatalog",
        function($log,$scope,$anchorScroll,$rootScope,$routeParams,$location,LoyaltyCardData,$timeout, gettextCatalog)
        {
            $scope.currentLoyaltyCardId =  parseInt($routeParams.loyaltyCardId);
            $scope.redirectToHomeWhenAccessIsNotGranted();
            $scope.$watch('ad.dataLoaded', function(newValue, oldValue)
            {
                if (newValue)// && !$scope.ad.view.currentLoyaltyCardView)
                {
                    var loyaltyCard = LoyaltyCardData.getById( $scope.currentLoyaltyCardId);
                    if (loyaltyCard)
                    {
                        $scope.ad.msgErrorLoyaltyCard = "";
                        $scope.setCurrentLoyaltyCardView($scope.ad.view.loyaltyCardCategoryRootView.getLoyaltyCardView(loyaltyCard),false);
                    }
                    else
                    {
                        var msgError= gettextCatalog.getString("Nous sommes désolés mais cette carte de fidélité n'existe plus ou ne peut plus être achetée");
                        $scope.ad.msgErrorLoyaltyCard = msgError+".";
                    }
                    $timeout(function() {
                        if(window.FB) {
                            window.FB.XFBML.parse();
                        }
                    },200);
                }
            });

        }
    ]);


// WEBPACK FOOTER //
// ./js/controllers/customerSite/WebSiteLoyaltyCardCtrl.js